import { TrackingClient } from '@sparefoot/tracking-client';
import { get } from 'lodash';
import { BOOKINGS, trackingSuccess } from 'store/bookings/slice';

export default (store) => (next) => (action) => {
	if (action.type === BOOKINGS.CREATE_SUCCESS) {
		// TODO: Update finance related values etc
		TrackingClient.trackReservationCompleted({
			currency: 'usd',
			discounts: '',
			first_order_date: Date.now(),
			last_order_date: Date.now(),
			move_in_date: get(action, 'payload.moveIn'),
			promotion_code: get(action, 'payload.promoCode'),
			reservation_confirmation: get(action, 'payload.confirmationCode'),
			revenue: get(action, 'payload.estimatedRevenue'),
			tax: '',
			unit: {
				currency: 'usd',
				id: get(action, 'payload.bookedUnit.id'),
				variant_size: `${get(
					action,
					'payload.bookedUnit.physical.length'
				)} x ${get(action, 'payload.bookedUnit.physical.width')}`,
				price: get(action, 'payload.bookedUnit.price.meta'),
				quantity: 1,
			},
			unit_id: get(action, 'payload.bookedUnit.id'),
			unit_promo: get(action, 'payload.bookedUnit.promotion'),
			email: get(action, 'payload.email'),
			first_name: get(action, 'payload.firstName'),
			last_name: get(action, 'payload.lastName'),
			phone: get(action, 'payload.phone'),
		});

		() => {
			store.dispatch(
				trackingSuccess({
					confirmationCode: get(action, 'payload.confirmationCode'),
				})
			);
		};
	}

	return next(action);
};